/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type Signature`)
};

const es_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe Firma`)
};

const de_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signatur eingeben`)
};

const nl_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handtekening typen`)
};

const fr_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signature Dactylographiée`)
};

const it_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digita Firma`)
};

const pt_br2_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assinatura Digitada`)
};

const pt_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escrever Assinatura`)
};

const ja_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`署名を入力`)
};

const zh_sig_nav_type = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入签名`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_nav_type = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_nav_type(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_nav_type", locale)
	if (locale === "en") return en_sig_nav_type(inputs)
	if (locale === "es") return es_sig_nav_type(inputs)
	if (locale === "de") return de_sig_nav_type(inputs)
	if (locale === "nl") return nl_sig_nav_type(inputs)
	if (locale === "fr") return fr_sig_nav_type(inputs)
	if (locale === "it") return it_sig_nav_type(inputs)
	if (locale === "pt-BR") return pt_br2_sig_nav_type(inputs)
	if (locale === "pt") return pt_sig_nav_type(inputs)
	if (locale === "ja") return ja_sig_nav_type(inputs)
	return zh_sig_nav_type(inputs)
};